export default {
  getBannerList(state) {
    return state.bannerList;
  },
  getPopupList(state) {
    return state.popupList;
  },
  getExpiredDate() {
    return JSON.parse(localStorage.getItem('expiredDate'));
  },

  getPageInfo(state) {
    return state.pageInfo;
  }
};
